import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import SchedulerConfigForm from './SchedulerConfigForm';
import { SchedulerConfig, SchedulerConfigFormData } from '@/types/smsScheduler';

interface SchedulerEditDialogProps {
  open: boolean;
  config: SchedulerConfig | null;
  onClose: () => void;
  onSubmit: (data: SchedulerConfigFormData) => void;
  loading?: boolean;
  error?: string | null;
}

const SchedulerEditDialog: React.FC<SchedulerEditDialogProps> = ({
  open,
  config,
  onClose,
  onSubmit,
  loading = false,
  error = null
}) => {
  if (!config) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { minHeight: '500px' }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditIcon color="primary" />
          <Typography variant="h6" component="span">
            Edit Scheduler Configuration
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Update the scheduler configuration. Changes will take effect immediately 
          and the scheduler job will be re-registered with the new settings.
        </Typography>

        <SchedulerConfigForm
          mode="edit"
          initialData={config}
          onSubmit={onSubmit}
          onCancel={onClose}
          loading={loading}
          error={error}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SchedulerEditDialog;

